<template>
	<div class='forecast'>
        <div v-for="item in valuesForecast" class='forecast-grid-container' :key="item.id">
			<div class="forecast-grid-container-item">
				<span>{{item.area}}</span>
			</div>
			<div class="forecast-grid-container-item">
				<span>{{item.section}}</span>
			</div>
			<div class="forecast-grid-container-item">
				<span>{{item.section_lp}}</span>
			</div>
			<div class="forecast-grid-container-item">
                <span class='select-title'>Ослабление лесных насаждений, га</span>
				<custom-p-input v-model='item.forecast_s_weakening' type='number' :disabled='!actLpoIsDraft'/>
			</div>

			<div class="forecast-grid-container-item">
				<span class='select-title'>Усыхание лесных насаждений, га</span>
				<custom-p-input v-model='item.forecast_s_shrinking' type='number' :disabled='!actLpoIsDraft'/>
			</div>
			<div class="forecast-grid-container-item">
				<span class='select-title'>Развитие очагов вредных организмов, га</span>
				<custom-p-input v-model='item.forecast_s_pests' type='number' :disabled='!actLpoIsDraft'/>
			</div>
		</div>

		<div class='values-btn-row not-match-block' v-if='needToSaveChanges(valuesForecast, valuesForecastDB)'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='saveForecast(valuesForecast)'>Сохранить</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex';
    import requestToApi from "@/lib/requestToApi";
    const ROOT_API = process.env.VUE_APP_ROOT_API;
    const INSPECTION_FORECAST = ROOT_API + 'get_site_data/forecast.php';
	export default {
		name: 'InspectionForecastRemote',
		data() {
			return {
                valuesForecast: [],
                valuesForecastDB: [],
			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},
		},
		methods: {
            needToSaveChanges(current, db) {
                for (let i = 0; i < current.length; i++) {
                    if (!this.objectsIsDeepEqual(current[i], db[i])) {
                        return true;
                    }
                }
                return false;
            },
            objectsIsDeepEqual(object1, object2) {
                const objKeys1 = Object.keys(object1);
                const objKeys2 = Object.keys(object2);
            
                if (objKeys1.length !== objKeys2.length) return false;
            
                for (var key of objKeys1) {
                    const value1 = object1[key];
                    const value2 = object2[key];
            
                    const isObjects = this.isObject(value1) && this.isObject(value2);
            
                    if ((isObjects && !this.objectsIsDeepEqual(value1, value2)) ||
                    (!isObjects && value1 !== value2)
                    ) {
                        return false;
                    }
                }
                return true;   
            },
            isObject(object) {
                return object != null && typeof object === "object";
            },
            async saveForecast(valuesForecast) {
                let params = {
                    type: "post",
                    url: INSPECTION_FORECAST,
                    params: {lpo_id: this.lpo.lpo_id, forecast: JSON.stringify(valuesForecast)}
                }
                const result = await requestToApi(params);
                if (result.code == 0) {
                    this.getForecast();
                } else {
                    alert("ошибка сохранения: " + result.name)
                }
            },
            async getForecast() {
                let params = {
                    url: INSPECTION_FORECAST,
                    params: {lpo_id: this.lpo.lpo_id}
                }
                const data = await requestToApi(params);
                this.valuesForecastDB = JSON.parse(JSON.stringify(data));
                this.valuesForecast = data;
            },
			

			cancel() {
                this.valuesForecast = JSON.parse(JSON.stringify(this.valuesForecastDB));
			},


			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
            this.getForecast();
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}
    .forecast-grid-container {
		display: grid;
        grid-template-columns: 1fr 1fr 2fr 7fr 6fr 7fr; /* Задаем различные доли для каждой колонки */
        gap: 4px; /* Промежутки между блоками */
		margin-bottom: 6px;
	}
	.forecast-grid-container-item {
		border: 1px solid rgb(190, 188, 188);
		/*background-color: #4CAF50;*/ /* Цвет фона */
        /*color: white; *//* Цвет текста */
        padding: 6px; /* Отступы внутри блоков */
        text-align: center; /* Выравнивание текста по центру */
	}
</style>